export const NOTIFICATIONS_URL = '/admin/v2/notifications';
